import React, { useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { ComponentProps } from 'react';
import FreightManifest from './FreightManifest';
import { sharedPrintStyles, basePrintContainerStyle } from './printStyles';

type ManifestPayload = ComponentProps<typeof FreightManifest>;

function decodePayload(params: URLSearchParams): ManifestPayload | null {
  const payload = params.get('payload');
  if (!payload) return null;
  try {
    const decoded = atob(decodeURIComponent(payload));
    return JSON.parse(decoded) as ManifestPayload;
  } catch (err) {
    console.error('Failed to decode freight manifest payload', err);
    return null;
  }
}

const FreightManifestPrintPage: React.FC = () => {
  const [params] = useSearchParams();
  const data = useMemo(() => decodePayload(params), [params]);

  useEffect(() => {
    console.log('FreightManifestPrintPage mounted', { hasData: !!data });
  }, [data]);

  if (!data) {
    return (
      <div className="print-page" style={errorStyles}>
        <p>Missing or invalid print payload.</p>
      </div>
    );
  }

  return (
    <div className="print-page" style={pageStyle}>
      <style>{sharedPrintStyles}</style>
      <FreightManifest {...data} />
    </div>
  );
};

const pageStyle: React.CSSProperties = {
  ...basePrintContainerStyle,
  backgroundColor: '#fff',
  minHeight: '100vh',
  padding: 0,
};

const errorStyles: React.CSSProperties = {
  ...pageStyle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
};

export default FreightManifestPrintPage;

